module.exports = __webpack_public_path__ + "static/img/silver.fa75fa8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/leagueoflegends/ranks/silver.png
// module id = g/AB
// module chunks = 35